import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetCompanySettingsDto from "./dto/get-company-settings.dto";

export const CompanySettingsEffectActions = {
  getCompanySettings: `${Entities.CompanySettings}_getCompanySettings`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.CompanySettings,
  initSchema,
  aliasName: DIContainerKeys.CompanySettingsService,
})
export class CompanySettingsService extends HttpService {
  @loader(Loaders.GetCompanySettingsLoader)
  @action(DIContainerKeys.CompanySettingsService)
  public *getCompanySettings(dto: GetCompanySettingsDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetCompanySettingsLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetTaxesList),
        domain: API_DOMENS.CC_API,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetCompanySettingsLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.CompanySettings, dto.clientId, response);
    yield this.setLoaderState(Loaders.GetCompanySettingsLoader, false);
  }
}